export enum ContextKeys {
  PRINCIPAL = "PRINCIPAL",
  ANNUAL_INTREST_RATE = "ANNUAL_INTREST_RATE",
  MONTHLY_DEPOSIT = "MONTHLY_DEPOSIT",
  NUMBER_OF_YEARS = "NUMBER_OF_YEARS",
  MANAGEMENT_FEES_ENABLED = "MANAGEMENT_FEES_ENABLED",
  DEPOSIT_FEES_PERCENTAGE = "DEPOSIT_FEES_PERCENTAGE",
  ACCUMULATION_FEES_PERCENTAGE = "ACCUMULATION_FEES_PERCENTAGE",
}

export type ContextKey = ContextKeys;
